import { render, staticRenderFns } from "./SplitForm.vue?vue&type=template&id=8d9e74a0&"
import script from "./SplitForm.vue?vue&type=script&lang=js&"
export * from "./SplitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports